import * as React from 'react';

import Illustration, { IllustrationColorProps } from './Illustration';

export const IllustrationDineIn: React.FunctionComponent<IllustrationColorProps> = ({ color }) => {
  return (
    <Illustration
      color={color}
      strokes={
        <>
          <path d="M13.8508 35.2344C13.4888 33.7324 13.2969 32.1629 13.2969 30.5498C13.2969 28.3005 13.6694 26.1388 14.3566 24.1227" />
          <path d="M29.7166 49.5826C26.682 49.5826 23.845 47.9628 21.4367 45.6089" />
          <path d="M22.226 14.9811C25.6514 12.1613 30.0353 10.4687 34.8141 10.4687C45.7743 10.4687 54.6592 19.3728 54.6592 30.3567C54.6592 40.0806 47.6961 48.1739 38.494 49.9036" />
          <path d="M16.3321 28.9174L16.3319 14.4165C16.3352 14.0329 16.7747 13.8398 17.0376 14.1066C18.0187 15.1047 19.6881 17.4118 19.6881 21.564C19.6881 27.4439 18.3769 28.9174 18.3769 28.9174" />
          <path d="M16.1915 31.1136L15.3172 48.2443H18.8141C18.8141 48.2443 18.5492 39.4483 18.5269 36.4483C18.5046 33.4482 18.5269 31.5528 18.5269 31.5528" />
          <path d="M21.8738 29.7959L25.2697 36.5868" />
          <path d="M23.1852 28.0389L26.2188 34.2955" />
          <path d="M24.9336 27.1604L29.2436 34.4379" />
          <path d="M26.9107 37.6719L35.8611 57.0293L38.0466 56.1508" strokeLinejoin="round" />
          <path d="M36.9676 54.3348L28.8675 37.2632" strokeLinejoin="round" />
          <path d="M45.2184 37.4146C42.9033 40.849 38.9818 43.1072 34.5345 43.1072" />
          <path d="M26.9099 19.7856C29.0444 18.2128 31.6815 17.2836 34.5345 17.2836C37.7159 17.2836 40.6275 18.4389 42.8753 20.3544" />
        </>
      }
      shadows={
        <>
          <path d="M29.7417 18.3755L26.682 20.1325C28.2774 19.4199 31.8004 20.8068 34.9869 21.011C38.0861 21.2095 40.8434 20.2108 42.8548 20.5717L38.9209 18.3755L34.1127 17.0577L29.7417 18.3755Z" />
          <path d="M45.449 37.7274L45.4774 37.7024C45.4379 37.762 45.4316 37.7673 45.449 37.7274L41.9806 40.7772L38.0467 42.5342L34.1127 42.9734C35.602 42.3499 42.4177 38.1417 44.6032 32.4314C47.7554 33.2233 45.6087 37.3625 45.449 37.7274Z" />
          <path d="M15.3173 48.6837L16.1915 30.6744V14.4222L15.7544 13.9829C15.7544 13.9829 11.8205 17.9362 10.072 28.9174C8.32362 39.8987 12.6947 48.6837 12.6947 48.6837H15.3173Z" />
          <path d="M21.874 46.0482L18.8142 43.4127C19.547 45.7268 17.924 47.3456 19.2515 48.6837C22.3588 51.8156 29.6812 54.4965 31.9272 54.3939L35.8611 57.4687L31.053 46.9267L26.6819 37.7024L24.4964 35.5062L30.1788 49.5622L26.245 49.1229L21.874 46.0482Z" />
        </>
      }
      dots={
        <>
          <circle cx="37.1982" cy="28.0604" r="0.9" />
          <circle cx="33.7014" cy="28.0604" r="0.9" />
          <circle cx="35.4498" cy="25.4249" r="0.9" />
          <circle cx="35.4498" cy="30.6959" r="0.9" />
          <circle cx="38.9467" cy="31.5744" r="0.9" />
          <circle cx="35.4498" cy="34.2098" r="0.9" />
          <circle cx="32.8272" cy="36.8454" r="0.9" />
          <circle cx="35.4498" cy="38.6024" r="0.9" />
          <circle cx="32.8272" cy="32.4529" r="0.9" />
          <circle cx="30.2046" cy="29.8174" r="0.9" />
          <circle cx="30.2046" cy="26.3034" r="0.9" />
          <circle cx="31.953" cy="23.6679" r="0.9" />
          <circle cx="26.7077" cy="24.5465" r="0.9" />
          <circle cx="40.6951" cy="28.0604" r="0.9" />
          <circle cx="45.0661" cy="27.1819" r="0.9" />
          <circle cx="41.5693" cy="24.5465" r="0.9" />
          <circle cx="42.4435" cy="30.6959" r="0.9" />
          <circle cx="38.9467" cy="34.2098" r="0.9" />
        </>
      }
    />
  );
};

export default IllustrationDineIn;
